import Image from 'next/image';
import React from 'react';
import cx from 'classnames';

import styles from './AboutUsSection.module.scss';

const AboutCeoSection = ({ data }: { data: any }) => {
  return (
    <div
      className={cx('text-center items-center flex flex-col', styles.container)}
    >
      <p className="text-white">{data.ceoSection}</p>
      <Image
        className="mt-4 rounded"
        width={390}
        height={470}
        src="/images/oem_ceo.jpg"
        alt="About us image"
      />
      <p className="text-white mt-2">Jaxon B. the CEO of OEM Stock Group</p>
    </div>
  );
};

export default AboutCeoSection;
